export * from './setting-icon';
